export default function XSD_Restrictions() {
  return (
    <div>
      <h1>XSD_Restrictions</h1>
      <p>This is the XSD_Restrictions component.</p>
    </div>
  );
}